<template>
  <div>
    <div class="chart" :style="{'height':`${height}px`}" :id="key">
    </div>
    <div class="divLegend row" style="padding-bottom:15px;">
      <!--leyenda recomendado-->
      <div v-if="recomendado" class="leyenda col-12" :style="height === 350 ? 'margin-left: 15px' : 'margin-left: 0px'">
        <div class="lineLeyenda"><hr class="line"></div>
        <div class="textLeyenda">{{textLeyenda}}</div>
      </div>
      <!--leyenda datosObjetivo-->
      <div v-if="datosObjetivo !== null" class="leyenda2 col-12" :style="height === 350 ? 'margin-left: 15px' : 'margin-left: 0px'">
        <div class="lineLeyenda"><hr class="line2"></div>
        <div class="textLeyenda">Objetivo: {{datosObjetivo.datoObjetivo}} {{datosObjetivo.unidadMedida}}
          <span class="fechaObjetivoLegend"> para {{ datosObjetivo.fechaDatoObjetivo | dateMonthYear | capitalize }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';

import * as am4charts from '@amcharts/amcharts4/charts';
import am4lang_es_ES from '@amcharts/amcharts4/lang/es_ES'; // eslint-disable-line
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';
import { v4 as uuidv4 } from 'uuid';
am4core.useTheme(am4themesAnimated);

export default {
  props: {
    height: Number,
    chartData: Array,
    periodData: String,
    recomendado: Number,
    tipoRecomendado: String,
    recomendadoPor: String,
    unidadMedida: String,
    datosObjetivo: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      textLeyenda: '',
      key: uuidv4()
    };
  },
  watch: {
    chartData () {
      this.chartDispose();
      this.drawnChart();
    }
  },
  created () {
    this.fillData();
  },
  mounted () {
    this.drawnChart();
  },
  beforeDestroy () {
    this.chartDispose();
  },
  methods: {
    chartDispose () {
      if (this.chart) {
        this.chart.dispose();
      }
    },
    fillData () {
      this.textLeyenda = this.tipoRecomendado + ' (' + this.recomendadoPor + '): ' + this.recomendado + ' ' + this.unidadMedida;
    },
    drawnChart () {
      let chart = am4core.create(this.key, am4charts.XYChart);
      chart.responsive.enabled = true;

      chart.dateFormatter.language = new am4core.Language();
      chart.dateFormatter.language.locale = am4lang_es_ES; // eslint-disable-line

      chart.zoomOutButton.disabled = true;

      // se añade a la grafica el valor recomendado para que se represente eje y correctamente
      if (this.recomendado) {
        this.chartData.forEach(element => {
          element['value2'] = this.recomendado;
        });
      }

      // se añade a la grafica el datoObjetivo
      if (this.datosObjetivo !== null) {
        this.chartData.forEach(element => {
          element['value3'] = this.datosObjetivo.datoObjetivo;
        });
      }

      chart.data = this.chartData;
      this.valorRecomendado = this.recomendado;

      chart.maskBullets = false;

      // Create axes
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.dateFormats.setKey('month', 'MMM yyyy');
      dateAxis.dateFormats.setKey('day', 'MMM yyyy');
      dateAxis.startLocation = 0.2;
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 0.2;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.extraMin = 0.2;

      // Disable grid
      dateAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.grid.template.disabled = true;

      switch (this.periodData) {
        case 'month':
          dateAxis.baseInterval = {
            'timeUnit': 'month',
            'count': 1
          };
          break;
        case 'year':
          dateAxis.baseInterval = {
            'timeUnit': 'year',
            'count': 1
          };
          break;
        default:
          dateAxis.baseInterval = {
            'timeUnit': 'month',
            'count': 1
          };
          break;
      }

      // Set Limit Line Axis and Label
      if (this.valorRecomendado) {
        var range = valueAxis.axisRanges.create();
        range.value = this.valorRecomendado;
        range.grid.stroke = am4core.color('#367efd');
        range.grid.strokeWidth = 2;
        range.grid.strokeOpacity = 1;
      }

      if (this.datosObjetivo !== null) {
        var range2 = valueAxis.axisRanges.create();
        range2.value = this.datosObjetivo.datoObjetivo;
        range2.grid.stroke = am4core.color('#37b0be');
        range2.grid.strokeWidth = 2;
        range2.grid.strokeOpacity = 1;
      }

      // Disable axis labels
      dateAxis.renderer.labels.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      valueAxis.renderer.labels.template.fontSize = 10;

      dateAxis.renderer.labels.template.fontSize = 9;
      dateAxis.renderer.labels.template.rotation = -50;
      dateAxis.renderer.labels.template.dx = -15;

      // Disable tooltip
      valueAxis.tooltip.disabled = true;
      dateAxis.tooltip.disabled = true;

      // Create gradient fill color
      let gradientFill = new am4core.LinearGradient();
      gradientFill.addColor(am4core.color('#A6DA46'));
      gradientFill.addColor(am4core.color('#E3E3E3'));

      // Create series
      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = 'value';
      series.dataFields.dateX = 'date';
      series.strokeWidth = 2;
      series.stroke = '#AADC14';
      series.fillOpacity = 0.5;
      series.fill = gradientFill;
      // para dar curvatura a la grafica (por defecto une puntos con lineas rectas)
      series.tensionX = 0.95;
      series.tensionY = 1;

      if (this.valorRecomendado) {
        var series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.valueY = 'value2';
        series2.dataFields.dateX = 'date';
        series2.fillOpacity = 0;
      }

      if (this.datosObjetivo !== null) {
        var series3 = chart.series.push(new am4charts.LineSeries());
        series3.dataFields.valueY = 'value3';
        series3.dataFields.dateX = 'date';
        series3.fillOpacity = 0;
        series3.stroke = '#37b0be';
      }

      if (this.height === 350) {
        dateAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.labels.template.disabled = false;

        let circleBullet = series.bullets.push(new am4charts.CircleBullet());
        circleBullet.circle.stroke = am4core.color('grey');
        circleBullet.circle.fill = am4core.color('#fff');
        circleBullet.circle.strokeWidth = 2;
        circleBullet.circle.scale = 0.7;

        var bullet3hover = circleBullet.states.create('hover');
        bullet3hover.properties.scale = 1.4;

        circleBullet.tooltipText = 'Valor: [bold]{value}[/]\n Fecha: [bold]{date.formatDate(\'YYYY-MM-dd\')}';
        series.tooltip.getFillFromObject = false;
        series.tooltip.background.fill = am4core.color('#5f5f5f');

        // ejes grafica

        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = am4core.color('#979797');

        dateAxis.renderer.line.strokeOpacity = 1;
        dateAxis.renderer.line.strokeWidth = 2;
        dateAxis.renderer.line.stroke = am4core.color('#979797');
      }
      gradientFill.rotation = 40;

      // Remove logo
      chart.logo.disabled = true;

      this.chart = chart;
    }
  }
};
</script>

<style lang="scss" scoped>
.chart{
  width: 100%;
}
.leyenda{
  font-size: 12px;
  font-weight: bold;
  color: #367efd;
  display: flex;
  align-items: baseline;
}
.leyenda2{
  font-size: 12px;
  font-weight: bold;
  color: #37b0be;
  display: flex;
  align-items: baseline;
}
.lineLeyenda{
  width: 15px;
  margin-right: 10px;
  display: flex;
  align-self: center;
}
.line, .line2{
  height: 2px;
  width: 15px;
  background-color: #367efd;
  border-style: none;
}
.line2{
  background-color: #37b0be;
  border-style: none;
}
.textLeyenda{
  justify-content: left;
  text-align: left !important;
  padding-right: 15px;
}
.fechaObjetivoLegend{
    font-family: DINPro;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.48px;
    color: #454545;
  }
</style>
